// extracted by mini-css-extract-plugin
export default {"tooltip":"_ece2d9fd","right":"_4aa64768","middleArrow":"_d7acbe9c","open":"_2392bdc"};